const initialState = {
    data: [],
    dataview:[],
    dataview2:[],
    dataview3:[],
  };
  
  const Newdonationreducer = (state = initialState, action: any) => {
    switch (action.type) {
      case 'FETCH_DATA_SUCCESS':
        return { ...state, data: action.payload };
      case 'FETCH_DATA_SEARCH_SUCCESS':
        return{ ...state, dataview: action.payload }
        case 'FETCH_DATA_SEARCH2_SUCCESS':
          return{ ...state, dataview2: action.payload }
          case 'FETCH_DATA_SEARCH3_SUCCESS':
          return{ ...state, dataview3: action.payload }
      default:
        return state;
    }
  };
  
  export default Newdonationreducer;
  
  